import React from 'react'
import {
  RouteProps as ReactDOMRouterProps,
  Route as ReactDOMRoute,
  RouteComponentProps,
} from 'react-router-dom'

interface RouteProps extends ReactDOMRouterProps {
  component: React.ComponentType<any>
}

const Route: React.FC<RouteProps> = ({ component: Component, ...rest }) => {
  return (
    <ReactDOMRoute
      {...rest}
      render={(props: RouteComponentProps) => <Component {...props} />}
    />
  )
}

export default Route
